import React from 'react';
import {TabView} from '../../../components/tab/TabView';
import {VideoActiveTable, VideoCompletedTable} from './VideoTable';
import {SearchFilter} from '../../../components/filter/Filters';
import {useFilter} from '../../../controllers/useFilter';

export const VideoTabView = props => {
  const {route: {params} = {}} = props;
  const {onChangeFilter, searchValue} = useFilter({});
  const tabs = {
    active: {
      label: 'Active',
      view: <VideoActiveTable searchValue={searchValue} />,
    },
    completed: {
      label: 'Completed',
      view: <VideoCompletedTable searchValue={searchValue} />,
    },
  };
  return (
    <TabView
      tabs={tabs}
      params={params}
      {...props}
      actions={[
        <SearchFilter
          value={searchValue}
          onChangeFilter={onChangeFilter}
          placeholder="Search"
        />,
      ]}
    />
  );
};
